module.exports = __webpack_public_path__ + "static/img/traning1.6810a504.png";